import { SnackbarManager } from '@cmg/design-system';
import { useState } from 'react';

import {
  uploadParticipationSet,
  UploadParticipationSetsFromCsvFileResponse,
} from '../../../../api/dlgw/participation-sets/apiCalls';
import {
  allocationNotionalUsdHeaderMapping,
  allocationSharesHeaderMapping,
  aumHeaderMapping,
  indicationNotionalUsdHeaderMapping,
  indicationSharesHeaderMapping,
  investorNameHeaderMapping,
  investorTypeHeaderMapping,
  isRoadshowParticipantHeaderMapping,
} from '../column-definitions';

type HeaderNameMapping = {
  field: string;
  headerName: string;
};
export type Params = {
  offeringId: string;
  participationRecordsInput: File | null;
  onCompleted?: () => void;
  headers: string[] | null;
};

export const participationSetHeaders = [
  investorNameHeaderMapping,
  investorTypeHeaderMapping,
  aumHeaderMapping,
  allocationSharesHeaderMapping,
  allocationNotionalUsdHeaderMapping,
  indicationSharesHeaderMapping,
  indicationNotionalUsdHeaderMapping,
  isRoadshowParticipantHeaderMapping,
];

export const createHeaderMappings = (headers: string[]) => {
  const headerMappings: HeaderNameMapping[] = [];
  participationSetHeaders.forEach(({ fieldName, acceptedHeaders }) => {
    headers.forEach(headerName => {
      if (acceptedHeaders.includes(headerName)) {
        headerMappings.push({
          field: fieldName,
          headerName,
        });
      }
    });
  });
  return headerMappings;
};
export const useUploadParticipation = ({
  offeringId,
  participationRecordsInput,
  onCompleted,
  headers,
}: Params) => {
  const [uploadResult, setUploadResult] = useState<UploadParticipationSetsFromCsvFileResponse>();

  return {
    uploadSet: async () => {
      try {
        if (!!participationRecordsInput && !!headers) {
          const response = await uploadParticipationSet({
            offeringId,
            file: participationRecordsInput,
            mappings: createHeaderMappings(headers),
          });
          setUploadResult(response);
          if (response.ok && !response.data.error) {
            SnackbarManager.success('Participation set uploaded.');
            onCompleted && onCompleted();
          }
        }
      } catch (error) {
        SnackbarManager.error(
          'An error has occurred while trying to upload participation set. Please try again later.'
        );
      }
    },
    uploadResult,
  };
};
